define.alias("shared/components/shared/ui/calculating-state", "settings/components/shared/ui/calculating-state");